module.exports = __webpack_public_path__ + "static/email-template-receipt-elephanty-d708f159d6fcdd8e8f6be2fa916fbf8d.png";